<style lang="stylus">
@import '../../../stylesheet/variable.styl';
@import '../../../stylesheet/view/preorder.styl';
</style>
<template>
  <div
    :class="canNotScroll ? 'preorder preorder-showLayer':'preorder'"
    ref="preorder"
    v-track="{act: 'ready', data: {id: 384}}"
  >
    <my-header showBack :style="isShowPayItem ?'position:fixed':'position:absolute'">
      <div class="restTime" slot="right">{{restTime}}</div>
    </my-header>
    <div class="decorate"></div>
    <delay-info :cardData="initInfo"></delay-info>
    <goods-info ref="goodsInfo" :productsType="productsType" :totalPrice="totalPrice"></goods-info>
    <div @click="chooseInnerPay">
      <inner-pay v-if="canCardPay" :cardData="initInfo" :isChecked="isUseInnerPay"></inner-pay>
    </div>
    <div class="extend-error-msg">{{extendInputError}}</div>

    <deduction-detail @hideDetail="hideDeductionDetail" :isShow="isShowDeductionDetail"></deduction-detail>
    <div :class="['pay',isShowPayItem?'':'pay-absolute']">
      <div class="show-detail" v-show="isDeductionButtonShow" @click="showDeductionDetail()">
        <icon
          size="15"
          color="rgb(121,125,130)"
          v-show="!isShowDeductionDetail"
        >sousuo-paixujiantoushang</icon>
        <icon
          size="15"
          color="rgb(121,125,130)"
          v-show="isShowDeductionDetail"
        >sousuo-paixujiantouxia</icon>
        <span>抵扣明细</span>
      </div>
      <div v-if="this.isCashPay"
        :class="canClick? 'to-pay': 'to-pay cannot'"
        @click="toPay"
        v-track="{act:'click',data:{id: 385}}"
      >提交订单</div>
      <div v-else
        :class="canClick? 'to-pay': 'to-pay cannot'"
        @click="askToPay"
        v-track="{act:'click',data:{id: 385}}"
      >提交订单</div>
      
      <div class="need-pay">
        <span>
        <decimal-price :price="needPay" decimalSize="10px" :unit="true" :forcePoint="true"/>
         
        </span>
      </div>
      <span class="actPay_text">实付</span>
    </div>

    <sec-pwd-input
      ref="secPwdBox"
      v-if="showSecPwd"
      @code-value="codeVal"
      @close-box="closeSecPwd"
      :secPwd="secPwd"
      :secPwdMessage="secPwdMessage"
    ></sec-pwd-input>
    <follow-wechat page="1" ref="followWC" @followWC-page-close="closeFollowPage"></follow-wechat>
    <cash-pay
      @cancel-cash-pay="cancelCashPay"
      :payOrderId="payOrderId"
      v-if="showCashPay"
      :productsType="productsType"
      :orderType="orderType"
    ></cash-pay>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import moment from "moment";
import _ from "underscore";
import op from "object-path";
import cookie from "../../lib/cookie.js";
import CONSTANT from "../../constant/preorder";
import CONSTANT_COOKIE from "../../constant/cookie.js";

import md5 from "MD5";
import { Toast, MessageBox } from "mint-ui";
import { getHostName, sessionStore } from "../../util/function.js";
import cloneDeep from "lodash.clonedeep";
import RSA from "../../util/RSA.js";
import myHeader from "../../components/header.vue";
import secPwdInput from "./sub_view/sec_pwd_input.vue";
import cardsItem from "./sub_view/cards_item.vue";
import addresseeInfo from "./sub_view/addressee_info.vue";
import goodsInfo from "./sub_view/goods_info.vue";
import followWechat from "../../components/follow_wechat.vue";
import couponItem from "./sub_view/coupon_item.vue";
import delayInfo from "./sub_view/delay_info.vue";
import innerPay from "./sub_view/card_inner_pay.vue";
// import priceDetail from './sub_view/price_detail.vue'
import cashPay from "./cash.vue";
import extendInput from "./sub_view/extend_input.vue";
import icon from "../../components/icon.vue";
import deductionDetail from "../../components/deduction_detail.vue";
import balanceItem from "./sub_view/balance_item.vue";
import cardDelayHelp from "../../components/caed-delay-help.vue";
import preOrderTips from "../../components/preorder-tips.vue";
import { trackData } from "../../directives/track.js";
import decimalPrice from '../../components/decimal-price.vue'
let rsa = new RSA();
const OVERTIME = "00:00";
export default {
  data() {
    return {
      // products:[],
      thirdOrderId: "", //第三方订单
      showSecPwd: false, //显示安全密码框
      secPwd: "", //安全密码
      canClick: true, //可以点击确认
      restTime: "", //订单剩余时间
      itv: {}, //计时器,
      secPwdMessage: "", //安全密码的报错信息
      isFocusInput: false, //input是否被focus,
      pwdIsFocus: false,
      isUseInnerPay:false,
      card:{
        sign:""
      },
      showMongoliaLayer: false, //页面显示浮层
      // needPay: 0,
      showCashPay: false,
      payOrderId: "",
      extendInputError: "",
      isShowDeductionDetail: false, //是否显示抵扣详情
      destroyState: false, //是否要删除vuex state
      activeInfo: {
        activeCode: this.$route.query.activeCode || "",
        groupCode: this.$route.query.groupCode || ""
      },
      PRODUCT_TYPE_ELECTRONIC_TICKET:
        CONSTANT.PREORDER_PRODUCT_TYPE_ELECTRONIC_TICKET, //电子票
      PRODUCT_TYPE_FILM_TICKET: CONSTANT.PREORDER_PRODUCT_TYPE_FILM_TICKET, //订座票
      PRODUCT_TYPE_OIL_CARD: CONSTANT.PREORDER_PRODUCT_TYPE_OIL_CARD, //加油卡充值
      PRODUCT_TYPE_PHONE_COST: CONSTANT.PREORDER_PRODUCT_TYPE_PHONE_COST, //话费，
      PRODUCT_TYPE_NET_COST: CONSTANT.PREORDER_PRODUCT_TYPE_NET_COST, //流量
      PRODUCT_TYPE_EXCHANGE_CODE: CONSTANT.PREORDER_PRODUCT_TYPE_EXCHANGE_CODE, //兑换码
      PRODUCT_TYPE_NORMAL: CONSTANT.PREORDER_PRODUCT_TYPE_NORMAL //普通商品
    };
  },
  components: {
    myHeader,
    cardsItem,
    addresseeInfo,
    goodsInfo,
    secPwdInput,
    followWechat,
    couponItem,
    delayInfo,
    innerPay,
    // priceDetail,
    cashPay,
    extendInput,
    icon,
    deductionDetail,
    balanceItem,
    cardDelayHelp,
    preOrderTips,
    decimalPrice
  },
  beforeRouteLeave(to, from, next) {
    // 导航离开该组件的对应路由时调用
    // 可以访问组件实例 `this`
    clearInterval(this.itv);

    if (
      to.name == "userAddressSelect" ||
      to.name == "preorderCards" ||
      to.name == "preorderPayCallback" ||
      to.name == "preorderGoodsList" ||
      to.name == "preorderCoupon" ||
      to.name == "userOrderDetail" ||
      to.name == "preorderPayWechat"
    ) {
      if (to.name == "preorderPayCallback" || to.name == "preorderPayWechat") {
        this.destroyState = true;
      }
      next();
      return false;
    }
    if (this.orderType == 2) {
      // 支付时间过期返回处理
      if (this.restTime == OVERTIME) {
        trackData({ id: 371 });
        this.cancelTicketOrder({
          orderId: this.orderKey
        })
          .then(() => {
            next();
          })
          .catch(() => {
            setTimeout(() => {
              next();
            }, 2000);
          });
      } else {
        MessageBox({
          message: "退出将释放您锁定的座位",
          showConfirmButton: true,
          showCancelButton: true,
          confirmButtonText: "取消",
          cancelButtonText: "确认",
          cancelButtonHighlight: true,
          closeOnClickModal: false
        }).then(action => {
          if (action !== "cancel") {
            next(false);
          } else {
            trackData({ id: 371 });
            this.cancelTicketOrder({
              orderId: this.orderKey
            })
              .then(() => {
                next();
              })
              .catch(() => {
                setTimeout(() => {
                  next();
                }, 2000);
              });
          }
        });
      }
      this.destroyState = true;
      return;
    }

    MessageBox({
      message: "好货不等人，确认返回吗？",
      showConfirmButton: true,
      showCancelButton: true,
      confirmButtonText: "再想想",
      cancelButtonText: "返回",
      closeOnClickModal: false
    }).then(action => {
      if (action !== "cancel") {
        next(false);
      } else {
        this.destroyState = true;
        next();
      }
    });
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 100);
      if (!cookie(CONSTANT_COOKIE.COOKIE_USER_X_TOKEN)) {
        window.location.href = `${getHostName()}/mz-auth/#/connect/login?redirectUri=${getHostName()}/v5/#/preorder/${
          this.$route.params.key
        }/cash`;
      }

      this.initInformation();
      // this.setOrderInterval();
      this.checkWechatFollow();
    });
  },
  destroyed() {
    if (!this.destroyState) {
      return;
    }
    setTimeout(() => {
      this.$store.commit("clearAddress");
      this.$store.commit("initState");
    }, 1000);
  },
  watch: {
    secPwd(newVal, oldVal) {
      if (`${newVal}`.length > 0) {
        this.secPwdMessage = "";
      }
      if (`${newVal}`.length >= 6) {
        setTimeout(() => {
          this.toPay();
        }, 1000);
      }
    }
  },
  computed: {
    ...mapState({
      addressSelected: state => state.address.selectedAddress, //选中的地址
      skuList: state => state.preorder.preorderSkuList,
      orderKey: state => state.preorder.orderKey, //电影订单的订单号或普通订单缓存key
      selectedCards: state => state.preorder.selectedCards, //选择支付的卡
      infoNeeded: state => state.preorder.infoNeeded, //页面需要展示的用户信息
      initInfo: state => state.preorder.orderInitInfo, //普通订单数据
      orderType: state => state.preorder.orderType, //订单类型
      extendInput: state => state.preorder.extendInput, //扩展输入框
      extendInputValue: state => state.preorder.extendInputValue, //用户输入的值
      endTime: state => state.preorder.filmData.endPayTime || 0, //订单的截止时间
      oilCardId: state => state.preorder.userInput.oilCardId,
      canCardPay: state =>
        op(state.preorder).get("orderInitInfo.0.canCardPay") || 0,//是否允许卡内支付
      isCashPay: state =>
        op(state.preorder).get("orderInitInfo.0.postponeInfo.isCashPay")!==0,//是否亏损阻止下单：true允许支付,false不允许支付
      isCardPay: state => state.preorder.payLimit.isCardPay == 0,
      isCouponPay: state => state.preorder.payLimit.isCouponPay == 0 && false, // FIXME: 暂时强制屏蔽现金券
      isBalancePay: state => state.preorder.payLimit.isBalancePay == 0,
      selectedCoupon: state => state.preorder.selectedCoupon,
      expressSku: state => state.preorder.expressSku,
      cardsDeduction: state =>
        op(state.preorder.selectedCards).get("deductionInfo.deductionValue") ||
        0,
      couponDeduction: state =>
        op(state.preorder.selectedCoupon).get("deductionInfo.deductionValue") ||
        0,
      feedbackMsg: state => state.preorder.feedbackMsg,
      extendsList: state =>
        op(state).get("preorder.preorderGoodsExtend.list") || [],
      preorderId: state => op(state).get("preorder.preorderId"),
      balanceDedcution: state => {
        return op(state.preorder.selectedBalance).get(
          "deductionInfo.deductionValue"
        ) && state.preorder.hasUsedBalance
          ? op(state.preorder.selectedBalance).get(
              "deductionInfo.deductionValue"
            )
          : 0;
      },
      preorderId: state => op(state).get("preorder.preorderId"),
      selectedBalance: state => state.preorder.selectedBalance,
      cardDelayPrice: state => op(state).get("preorder.preorderSkuList.0.price")
    }),
    hasSelectedAddress() {
      if (_.isEmpty(this.addressSelected)) {
        return false;
      }
      return true;
    },
    totalPrice() {
      let total = 0;
      _.each(this.skuList, sku => {
        total = total + sku.count * sku.price;
      });
      return total;
    },
    productsType() {
      if (!this.extendsList.length) {
        return null;
      } else if (
        this.extendsList[0].productType == this.PRODUCT_TYPE_EXCHANGE_CODE
      ) {
        let normalProduct = this.extendsList.find(item => {
          return item.productType == this.PRODUCT_TYPE_NORMAL;
        });
        if (normalProduct) {
          return this.PRODUCT_TYPE_NORMAL;
        } else {
          return this.PRODUCT_TYPE_EXCHANGE_CODE;
        }
      } else {
        return this.extendsList[0].productType;
      }
    },
    isShowPayItem() {
      return this.showSecPwd || this.isFocusInput || this.showCashPay
        ? false
        : true;
    },
    isDeductionButtonShow() {
      // 隐藏抵扣明细
      return false;
      // return op(this.selectedCoupon).get('epayList.length') > 0 || op(this.selectedCards).get('epayList.length') > 0
    },
    express() {
      if (!this.expressSku) {
        return 0;
      }
      return this.expressSku.price * this.expressSku.count;
    },
    needPay() {
      let needPay =
        this.isUseInnerPay?0:this.totalPrice;
      /**
      如果是选择了使用卡内扣款
        需要支付的钱 =  0
      否则
        需要支付的钱 =  this.totalPrice
      **/
    
      return needPay;
    },
    canNotScroll() {
      return (
        this.showMongoliaLayer ||
        this.showSecPwd ||
        this.isShowDeductionDetail ||
        this.showSecPwd
      );
    },
    isCardDelayOrder() {
      return this.orderType == CONSTANT.PREORDER_ORDER_TYPE_CARDDELAY;
    }
  },
  methods: {
    ...mapActions([
      "getAddressList",
      "getPreorderInfo",
      "getPreorderSkus",
      "getFilmPreOrder",
      "createOrder",
      "orderCheckPay",
      "cancelTicketOrder",
      "getPayLimit",
      "matchCardTotal",
      "getOrderCouponNum",
      "orderOptimalPay"
    ]),
    setOrderInterval() {
      let self = this;
      const now = cookie(CONSTANT_COOKIE.COOKIE_SERVICE_TIME);
      let rest = self.endTime - now;
      clearInterval(self.itv);
      this.itv = setInterval(() => {
        if (self.endTime == 0 || self.orderType == 1) {
          clearInterval(self.itv);
          return;
        }
        rest -= 1;
        self.restTime = moment.unix(rest).format("mm:ss");
        if (
          self.restTime == OVERTIME ||
          moment(moment.unix(self.endTime)).isBefore(moment.unix(now))
        ) {
          MessageBox.alert("订单已过期，请重新下单").then(action => {
            self.$router.go(-1);
          });
          clearInterval(self.itv);
          self.restTime = OVERTIME;
        }
      }, 1000);
    },
    focusInput() {
      this.extendInputError = "";
      this.isFocusInput = true;
    },
    blurInput() {
      this.isFocusInput = false;
    },
    codeVal(val) {
      this.secPwd = val;
    },
    async initInformation() {
      let self = this;
      let key = this.$route.params.key;

      if (!key) {
        return this.$router.go(-1);
      }

      if (key == this.orderKey) {
        //如果不是第一次进入该订单，无需再构造
        // this.setLogisticsMsg()
        return;
      }

      this.canClick = false;
      this.$store.commit("clearAddress");
      this.$store.commit("initState");

      this.$store.commit("setOrderKey", key);
      // this.getAddressList()
      await this.initPreorderGoodsInfo();
      if(this.canCardPay){
         await this.chooseInnerPay();
      }
      //await this.initPayMethods();
      // this.setLogisticsMsg()
      this.canClick = true;
    },
    async initPreorderGoodsInfo() {
      let self = this;
      let key = this.$route.params.key;
      //如果是电影订单
      if (this.$route.query.type == CONSTANT.PREORDER_ORDER_TYPE_FILM) {
        self.thirdOrderId = key;
        this.$store.commit("setOrderType", CONSTANT.PREORDER_ORDER_TYPE_FILM);

        await this.initFilm(key);
        setTimeout(() => {
          this.setOrderInterval();
        }, 0);
        return;
      }

      let preorderId = this.$route.query.preOrderId;

      //团购订单
      if (this.$route.query.type == CONSTANT.PREORDER_ORDER_TYPE_GROUPON) {
        this.$store.commit(
          "setOrderType",
          CONSTANT.PREORDER_ORDER_TYPE_GROUPON
        );
      } else if (
        this.$route.query.type == CONSTANT.PREORDER_ORDER_TYPE_SHOUFA
      ) {
        this.$store.commit("setOrderType", CONSTANT.PREORDER_ORDER_TYPE_SHOUFA);
      } else if (
        this.$route.query.type == CONSTANT.PREORDER_ORDER_TYPE_CARDDELAY
      ) {
        this.$store.commit(
          "setOrderType",
          CONSTANT.PREORDER_ORDER_TYPE_CARDDELAY
        );
      } else {
        this.$store.commit("setOrderType", CONSTANT.PREORDER_ORDER_TYPE_NORMAL);
      }
      let stringData = await this.getPreorderInfo({
        key: `pre-${key}`
      });
      let data = JSON.parse(stringData);
      self.$store.commit("setInitInfo", data);
      this.$store.commit("setPreorderId", preorderId);
      self.initGoods(preorderId);
    },
    async initGoods(key) {
      await this.$refs.goodsInfo.initGoods(key);
    },
    async initPayMethods() {
      let self = this;
      let data = {};
      let orderType = this.$route.query.type;

      let res = await this.getPayLimit({
        preOrderId: this.preorderId
      });
      if (res.isCardPay == 0 || res.isCouponPay == 0 || res.isBalancePay == 0) {
        self.initAssets({
          preOrderId: this.preorderId
        });
      }
    },
    async initAssets(data) {
      let cardNum = 0;
      let couponNum = 0;
      if (this.isCardPay) {
        this.matchCardTotal(data);
      }

      if (this.isCouponPay) {
        this.getOrderCouponNum(data);
      }

      await this.orderOptimalPay(data);
    },

    chooseInnerPay() {
      let data = {
        preOrderId: this.preorderId,
        cardList: [
          {
            content: this.initInfo[0].content,
            type: this.initInfo[0].type,
            selectCount: 0,
            isLastChange: 1
          }
        ],
        couponList: []
      };

      this.orderCheckPay(data)
        .then(data => {
          this.card = {
            sign:data.card.sign
          }
          this.isUseInnerPay = !this.isUseInnerPay
        })
        .catch(err => {
          this.isUseInnerPay = !this.isUseInnerPay
          console.log("<><><><", err);
        });
    },

    askToPay(){
      MessageBox.confirm("券内余额低于延期费用，请确认是否继续支付？").then(action => {
          if (action == 'cancel') {
            return
          }else{
            this.toPay();
          }
      })

    },
    async toPay() {
      if (await this.checkWechatFollow()) {
        return;
      }

      if (this.canClick == false) {
        return;
      }

      
      // if(!this.isCashPay){
      //     Toast('卡价值低于延期金额，无法延期')
      //     return 
      // }

      let data = this.payData();

      // if(this.isCardPay){
      //   this.innerPay();
      //   return
      // }

      if (data === false) {
        return;
      }
      this.canClick = false;
      let self = this;
      this.createOrder(data)
        .then(data => {
          this.payOrderId = data.payOrderId;
          this.showSecPwd = false;
          this.canClick = true;
          if (data.payAmount > 0) {
            this.showCashPay = true;
            return;
          }
          this.$router.replace({
            path: `/preorder/${data.payOrderId}/pay/callback/0?productType=${
              self.productsType
            }&orderType=${self.orderType}`
          });
          // this.$store.commit('initState')
        })
        .catch(e => {
          this.payError(e);
        });
    },
    payData() {
      let self = this;
      //填充卡数据
      let cards = [];
      // _.each(op(this.selectedCards).get("epayList"), card => {
      //   let res = {
      //     type: 3, //识别方式为卡唯一码
      //     content: rsa.encrypt(card.epayId, "base64")
      //   };
      //   let skuList = [];
      //   _.each(card.deductionList, sku => {
      //     skuList.push({
      //       skuId: sku.skuId,
      //       epayAmount: sku.deductionValue
      //     });
      //   });
      //   res.skuList = skuList;
      //   cards.push(res);
      // });
      var obj = this.initInfo[0]
      var currentCardInfo = {
        ...(obj.contentData),
        "skuList": [
            {
                "skuId": obj.skuId, 
                "epayAmount": obj.price*obj.dueDateMonths, 
                "epayCount": 1
            }
        ]
      }
      cards.push(currentCardInfo)
      
      //填充现金券数据
      let coupons = [];
      

      // 填充余额数据
      let balance = [];
      
      //填充要提交的数据
      /* 地址数据 */
      let addrData = {};

      /*  */
      let data = {
        remark: this.feedbackMsg,
        orderType: this.orderType,
        mobile: "",
        delivery: addrData,
        externalPayAmount:this.needPay,
        ePaySign: [],
        ePayDetails: {}
      };
      /* 卡数据 */
      if (cards.length !== 0 && this.isUseInnerPay) {
        data.ePayDetails.cards = cards;
        data.ePaySign.push({
          sign: self.card.sign,
          type: 4
        });
      }

      /* 安全密码 */
      if (this.secPwd != "") {
        data.secPassword = md5(this.secPwd);
      }
      this.orderType == 2
        ? (data.isFromCart = 0)
        : (data.isFromCart = this.initInfo[0].isFromCart);

      /* 填充商品扩展信息 */
      let extendInputClone = cloneDeep(this.extendInput);
      //将extendValue 的值写入extendInput
      for (let i = 0; i < extendInputClone.length; i++) {
        extendInputClone[i].attrValue = this.extendInputValue[i];
      }
      //将userInput的数据写入extendInput
      _.each(extendInputClone, extend => {
        if (extend.attrId == CONSTANT.PREORDER_ATTR_ID_MOBILE) {
          extend.attrValue = self.phone;
        } else if (extend.attrId == CONSTANT.PREORDER_ATTR_ID_OILCARD) {
          extend.attrValue = self.oilCardId;
        } else if (extend.attrId == CONSTANT.PREORDER_ATTR_ID_IDCARD) {
          extend.attrValue = self.addressSelected.idCard;
        } else if (extend.attrId == CONSTANT.PREORDER_ATTR_ID_NAME) {
          extend.attrValue = self.addressSelected.name;
        } else if (extend.attrId == CONSTANT.PREORDER_ATTR_ID_ADDRESS) {
          if (
            self.addressSelected.provinceName === self.addressSelected.cityName
          ) {
            extend.attrValue =
              self.addressSelected.cityName +
              self.addressSelected.districtName +
              self.addressSelected.address;
          } else {
            extend.attrValue =
              self.addressSelected.provinceName +
              self.addressSelected.cityName +
              self.addressSelected.districtName +
              self.addressSelected.address;
          }
        }
      });
      //  校验扩展信息
      for (let i = 0; i < extendInputClone.length; i++) {
        if (
          !extendInputClone[i].attrValue &&
          extendInputClone[i].isRequired == 1
        ) {
          this.extendInputError =
            `请输入${extendInputClone[i].attrName}` || "请将信息填写完整";
          setTimeout(() => {
            window.scrollTo(0, self.$refs.preorder.scrollHeight);
          }, 100);
          return false;
        }
      }

      //将extendInput 数据写入skuList
      let skuListClone = this.skuList;
      let skuList = [];
      _.each(skuListClone, sku => {
        let attrsExtend = cloneDeep(sku.deliveryAttr);
        _.each(attrsExtend, attr => {
          _.each(extendInputClone, extend => {
            if (attr.attrId == extend.attrId) {
              attr.attrValue = extend.attrValue;
            }
          });
        });
        skuList.push({
          skuId: sku.skuId,
          count: sku.count,
          price: sku.price,
          deliveryExtInfo: attrsExtend
        });
      });
      if (this.expressSku) {
        skuList.push(this.expressSku);
      }
      data.skuList = skuList;

      if (this.orderType == CONSTANT.PREORDER_ORDER_TYPE_FILM) {
        data.thirdOrderId = this.orderKey;
      }

      if (this.$route.query.extId && this.$route.query.extValue) {
        data.otherExtInfo = [
          {
            extId: parseInt(this.$route.query.extId),
            extValue: this.$route.query.extValue
          }
        ];
      }
      if (this.activeInfo.activeCode || this.activeInfo.groupCode) {
        data.activeInfo = this.activeInfo;
        const shareIdentifier = sessionStore.get("shareIdentifier");
        if (shareIdentifier) {
          data.activeInfo.shareIdentifier = shareIdentifier;
        }
      }

      // 填入卡延期商品需要的信息
      if (this.orderType == CONSTANT.PREORDER_ORDER_TYPE_CARDDELAY) {
        const cardDelayData = this.initInfo[0];
        data.cardPostponeInfo = {
          cardNum: `${cardDelayData.cardNum}`,
          memberId: parseInt(cardDelayData.memberId),
          dueDateMonths: cardDelayData.dueDateMonths,
          isBind: cardDelayData.isBind,
          newPeriod: cardDelayData.postponeInfo.newPeriod,
          content: cardDelayData.contentData.content,
          type: cardDelayData.contentData.type,
          endDate: cardDelayData.endDate,
          startDate: cardDelayData.startDate,
          postponeDay: cardDelayData.postponeInfo.postponeDay
        };
        data.mobile = cookie(CONSTANT_COOKIE.COOKIE_USER_MOBILE);
      }
      return data;
    },
    payError(e) {
      this.canClick = true;
      if (e.status == 6603021) {
        this.secPwd = "";
        this.$refs.addresseeInfo.setErrorMsg(
          "所选商品超出配送范围，请核对您的地址"
        );
        // this.addressErrorMsg = '所选商品超出配送范围，请核对您的地址'
        return;
      }
      if (e.status == 6803009) {
        //未输入安全密码

        // 解决支付密码框样式在5s手机上的bug
        this.secPwd = "";
        this.showSecPwd = true;
        setTimeout(() => {
          this.$refs.secPwdBox.reset();
        }, 0);
        return;
      }
      /* if (e.status == 6803008) {
            this.showSecPwd = false
            const self = this
            const html = "<div style='font-size: 17px;color: rgb(25,26,27);height: 24px;line-height: 24px;margin-bottom:20px;margin-top:7px;'>您未设置安全密码</div><div style='line-height: normal; text-align:left;font-size: 14px;color: rgb(25,26,27);margin-bottom: 9px'>使用余额或卖座卡请设置安全密码，以保证资金安全</div>"
            MessageBox({
              message: html,
              showConfirmButton: true,
              showCancelButton: true,
              confirmButtonText: '去设置',
              cancelButtonText: '取消',
              closeOnClickModal: false,
            }).then(action => {
              if (action !== 'cancel') {
                self.$refs.secPwdBox.goToSetSecPwd(0)
              }
            })
            return
          } */
      if (e.status == 6803008) {
        // 未设置安全密码
        location.href = `${getHostName()}/mz-auth/#/user/security-code`;
        return;
      }
      if (e.status == 6803007) {
        //安全密码错误
        this.secPwdMessage = e.msg;
        this.secPwd = "";
        this.showSecPwd = true;
        setTimeout(() => {
          this.$refs.secPwdBox.reset();
        }, 0);
        return;
      }

      if (e.status == 6803010) {
        MessageBox.alert(e.msg).then(() => {
          this.secPwd = "";
          if (this.showSecPwd) {
            this.$refs.secPwdBox.reset();
            this.showSecPwd = false;
          }
        });
        return;
      }

      this.secPwd = "";
      if (this.showSecPwd) {
        this.$refs.secPwdBox.reset();
        this.showSecPwd = false;
      }
      Toast({
        message: e.msg,
        position: "bottom",
        duration: 3000
      });
    },
    async initFilm(data) {
      const payOrderId = await this.$refs.goodsInfo.initFilm(data);
      if (payOrderId) {
        this.payOrderId = payOrderId;
        this.showCashPay = true;
      }
    },
    closeSecPwd() {
      this.showSecPwd = false;
      this.secPwd = "";
    },
    async checkWechatFollow() {
      return (this.showMongoliaLayer = await this.$refs.followWC.isPageShow());
    },
    closeFollowPage() {
      this.showMongoliaLayer = false;
    },
    cancelCashPay() {
      this.$router.replace({
        path: `/user/order/${this.payOrderId}?type=2`
      });
      this.$store.commit("clearAddress");
      this.$store.commit("initState");
      this.showCashPay = false;
    },

    showDeductionDetail() {
      this.isShowDeductionDetail = !this.isShowDeductionDetail;
    },
    hideDeductionDetail() {
      return (this.isShowDeductionDetail = false);
    }
  }
};
</script>
